module.exports = __webpack_public_path__ + "img/13.01465e82.png";